module.exports = __webpack_public_path__ + "img/LOGO.485bace7.png";